import { OnInit } from '@angular/core/';
import { MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component } from '@angular/core';

import { FormErrors } from 'app/shared/validators/generic-validators';
import { SnackBarService } from 'app/services/snackbar.service';
import { TimeKeepingActivity } from 'app/admin/applicationactivity/application-activity.model';
import { ApplicationActivityService } from 'app/admin/applicationactivity/application-activity.service';
import { MessageService } from 'app/services/messages.service';

@Component({
    selector: 'save-application-activity',
    templateUrl: './save-application-activity.component.html'
})
export class SaveApplicationActivityComponent implements OnInit {
    action: string;
    activityForm: FormGroup;
    activityDetails: TimeKeepingActivity;
    standardActivity: string;
    isLoading = false;
    formErrors = {
        'name': '',
        'rate': '',
    };
    validationMessages = {
        'name': {
            'required': 'Required field value.',
        },
        'rate': {
            'required': 'Required field value.',
        }
    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private fb: FormBuilder,
        private snackBarService: SnackBarService,
        private applicationActivityService: ApplicationActivityService
    ) { }

    ngOnInit() {
        this.buildForm();
        this.loadActivityForm();
    }

    buildForm() {
        this.activityForm = this.fb.group({
            name: [{ value: '', disabled: this.isEditAction() }, Validators.required],
            rate: ['', Validators.required],
        });
        this.activityForm.valueChanges.subscribe(data => this.onValueChanged(data));
        this.onValueChanged();
    }

    loadActivityForm() {
        if (this.activityDetails) {
            this.activityForm.patchValue({
                name: this.activityDetails.activityName,
                rate: this.activityDetails.activityRate,
            });
        } else if (this.standardActivity) {
            this.activityForm.patchValue({
                name: this.standardActivity
            });
        }
    }

    onValueChanged(data?: any) {
        if (!this.activityForm) {
            return;
        }
        FormErrors('activityForm', this);
    }

    isEditAction() {
        return this.action === 'Edit';
    }

    isAddAction() {
        return this.action === 'Add';
    }

    isActivityFormValid() {
        return this.activityForm.valid;
    }

    onSubmit({value, valid}) {
        const timeKeepingActivity = new TimeKeepingActivity();
        if (this.activityDetails) {
            timeKeepingActivity.id = this.activityDetails.id;
        }
        timeKeepingActivity.activityName = value.name;
        timeKeepingActivity.activityRate = value.rate;
        if (this.isEditAction()) {
            this.saveTimeKeepingActivity(timeKeepingActivity);
        } else {
            this.addTimeKeepingActivity(timeKeepingActivity);
        }
    }

    saveTimeKeepingActivity(timeKeepingActivity: TimeKeepingActivity) {
        this.applicationActivityService.saveTimeKeepingActivity(timeKeepingActivity)
            .subscribe(response => {
                if (response.flagResult) {
                    this.dialogRef.close(response);
                }
                this.callSnackBarService(response, this.action);
            }, err => {
                this.callSnackBarService(err, this.action);
            });
    }

    addTimeKeepingActivity(timeKeepingActivity: TimeKeepingActivity) {
        this.applicationActivityService.addTimeKeepingActivity(timeKeepingActivity)
            .subscribe(response => {
                if (response.flagResult) {
                    this.dialogRef.close(response);
                }
                this.callSnackBarService(response, this.action);
            }, err => {
                this.callSnackBarService(err, this.action);
            });
    }

    callSnackBarService(response: any, operation: string) {
        this.snackBarService
            .showStatus(response,
            operation === 'Add'
            && MessageService.ADD_APPLICATION_ACTIVITY_SUCCESS || MessageService.UPDATE_APPLICATION_ACTIVITY_SUCCESS,
            MessageService.APPLICATION_ACTIVITY_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/applicationactivity/saveapplicationactivity/save-application-activity.component.ts